namespace Nobox {

    export class FormResultProductsEditor extends Serenity.Extensions.GridEditorBase<CRM.ProductsRow> {
        protected getColumnsKey() { return NoBoxCRM.FormResultProductsColumns.columnsKey; }
        protected getDialogType() { return CRM.ProductsDialog; }
        protected getLocalTextPrefix() { return CRM.ProductsRow.localTextPrefix; }

        constructor(container: JQuery) {
            super(container);

            this.slickContainer.on('change', 'select', e => {
                var cell = this.slickGrid.getCellFromEvent(e);
                if (!cell)
                    return;

                var item = this.itemAt(cell.row);
                var field = this.slickGrid.getColumns()[cell.cell].field;
                item[field] = Q.toId($(e.target).val());
                this.view.updateItem(this.id(item), item);
            });
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
        }
        callbackTotal(total: number) {

        }
        private inputsChange(e: JQueryEventObject) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var pending = this.pendingChanges[item.Id];

            var effective = this.getEffectiveValue(item, field);
            var oldText: string;
            if (input.hasClass("numeric"))
                oldText = Q.formatNumber(effective, '0.##');
            else
                oldText = effective as string;

            var value;
            if (input.hasClass("numeric")) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else
                value = text;

            if (!pending) {
                this.pendingChanges[item.Id] = pending = {};
            }

            pending[field] = value;
            item[field] = value;
            var items = this.getItems();
            var indItems = items.findIndex(x => x.Id == item.Id);
            if (indItems != -1) {
                items[indItems].FinalTotalPrice = item["Quantity"] * item["TotalPrice"]
                this.setItems(items);
            }

            let totalPriceAllProduts = 0;
            items.forEach(fy => {
                totalPriceAllProduts += fy.FinalTotalPrice;
            });
            this.callbackTotal(totalPriceAllProduts);

            this.view.refresh();
            //this.refresh();

            if (input.hasClass("numeric"))
                value = Q.formatNumber(value, '0.##');

            input.val(value).addClass('dirty');
        }

        protected getButtons() {
            return [];
        }
        
        protected createToolbarExtensions() {
            super.createToolbarExtensions();

            Serenity.Widget.create({
                type: Serenity.ServiceLookupEditor,
                options: {
                    service: `/Services/${CRM.ProductsService.baseUrl}/List`,
                    idField: "Id",
                    textField: "ProductName",
                    sort: ["ProductName"],
                    pageSize: 10,
                    includeColumns: ["Id", "ProductName", "TotalPrice"],
                },
                element: e => e.attr('placeholder', '--select product to add--')
                    .css('float', 'left')
                    .appendTo(this.toolbar.element),
                init: w => w.change(async x => {
                    if (Q.isEmptyOrNull(w.value))
                        return;

                    let objPdt = null as CRM.ProductsRow;
                    await Q.serviceCall({
                        blockUI: true,
                        service: `/Services/${CRM.ProductsService.baseUrl}/Retrieve`,
                        request: {
                            EntityId: w.value
                        },
                        onSuccess: (res: Serenity.RetrieveResponse<CRM.ProductsRow>) => {
                            objPdt = res.Entity;
                        }
                    })

                    if (objPdt == null)
                        return;

                    if (Q.any(this.getItems(), i => i.Id.toString() == w.value)) {
                        Q.notifyWarning("Product already exist!");
                        return;
                    }

                    var item: CRM.ProductsRow = {
                        Id: Number(w.value),
                        ProductName: w.text,
                        Quantity: 1,
                        Currencies: objPdt.Currencies,
                        Image: objPdt.Image,
                        ProductCode: objPdt.ProductCode,
                        ProductDesc: objPdt.ProductDesc,
                        TotalPrice: objPdt.TotalPrice,
                        FinalTotalPrice: objPdt.TotalPrice
                    };

                    this.setNewId(item);

                    var items = this.getItems().slice();
                    items.push(item);
                    items.sort((a, b) => Q.turkishLocaleCompare(a.ProductName, b.ProductName));
                    this.setItems(items);
                    w.value = null;

                    let totalPriceAllProduts = 0;
                    items.forEach(fy => {
                        totalPriceAllProduts += fy.FinalTotalPrice;
                    });
                    this.callbackTotal(totalPriceAllProduts);
                })
            });
        }
        private pendingChanges: Q.Dictionary<any> = {};
        private getEffectiveValue(item, field): any {
            var pending = this.pendingChanges[item.ProductID];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }

            return item[field];
        }
        private numericInputFormatter(ctx) {
            if ((ctx.item as Slick.NonDataRow).__nonDataRow)
                return Q.htmlEncode(Q.formatNumber(ctx.value, '#0.##'));

            var klass = 'edit numeric text-right';
            var item = ctx.item as CRM.ProductsRow;
            var pending = this.pendingChanges[item.Id];

            if (pending && pending[ctx.column.field] !== undefined) {
                klass += ' dirty';
            }

            var value = this.getEffectiveValue(item, ctx.column.field) as number;

            return "<input type='text' style='max-width: 100px;' class='" + klass +
                "' data-field='" + ctx.column.field +
                "' value='" + Q.formatNumber(value, '0.##') + "'/>";
        }

        protected getColumns() {
            var columns = super.getColumns();

            var num = ctx => this.numericInputFormatter(ctx);
            columns.unshift({
                field: 'Remove Attendee',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-times text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });
            Q.first(columns, x => x.field === CRM.ProductsRow.Fields.Quantity).format = num;
            //Q.first(columns, x => x.field == CRM.ProductsRow.Fields.TotalPrice).format =
            //    ctx => `${Q.htmlEncode(ctx.item.currencies + " " + ctx.value)}`;

            return columns;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);

            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    var items = this.getItems();
                    if (items.length > 1) {
                        items.splice(row, 1);
                        this.setItems(items);

                        let totalPriceAllProduts = 0;
                        items.forEach(fy => {
                            totalPriceAllProduts += fy.FinalTotalPrice;
                        });
                        this.callbackTotal(totalPriceAllProduts);
                    } else {
                        Q.alert("Can't remove this product, at least must have 1 product")
                    }
                }
            }
        }

        // Tambahan
        protected getSlickOptions(): Slick.GridOptions {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            opt.enableTextSelectionOnCells = true;
            opt.selectedCellCssClass = "slick-row-selected";
            opt.enableCellNavigation = true;
            return opt;
        }

        protected createSlickGrid(): Slick.Grid {
            var grid = super.createSlickGrid();
            grid.setSelectionModel(new Slick.RowSelectionModel());

            // need to register this plugin for grouping or you'll have errors
            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            this.view.setSummaryOptions({
                aggregators: [
                    new Slick.Aggregators.Sum('FinalTotalPrice'),
                ]
            });

            return grid;
        }

    }
}
